import { useState } from 'react'

import type { IUsePagination } from './pagination.interface'

export function usePagination(): IUsePagination {
  const [pageCount, setPageCount] = useState(0)
  const [totalNumberOfRecords, setTotalNumberOfRecords] = useState(0)
  const [pageNumber, setPageNumber] = useState(1)
  const [recordsPerPage, setRecordsPerPage] = useState(50)

  return {
    pageCount,
    setPageCount,
    totalNumberOfRecords,
    setTotalNumberOfRecords,
    pageNumber,
    setPageNumber,
    recordsPerPage,
    setRecordsPerPage,
  }
}
